import React from 'react';

import { COLOR_GANT_CALENDAR_SELECTION } from '../../const';
import { useGantGridDatePeriodMetrics } from './useGantGridDatePeriodMetrics';

interface GantGridDatePeriodProps {
    typeGrid: 'header' | 'main';
}

export const GantGridDatePeriod: React.FC<GantGridDatePeriodProps> = ({ typeGrid }) => {
    const { x1, x2, width, height, isComponentVisible } = useGantGridDatePeriodMetrics(typeGrid);

    if (!isComponentVisible) {
        return null;
    }

    if (x1 === undefined || x2 === undefined) {
        throw new Error(`disappear x1 or x2: ${x1} ${x2}`);
    }

    return (
        <g style={{ mixBlendMode: 'normal', pointerEvents: 'none' }}>
            <rect x={x1} y={0} width={width} height={height} fill={COLOR_GANT_CALENDAR_SELECTION} opacity={0.05} />

            <line x1={x1} y1={0} x2={x1} y2={height} stroke={COLOR_GANT_CALENDAR_SELECTION} strokeWidth={1} />
            <line x1={x2} y1={0} x2={x2} y2={height} stroke={COLOR_GANT_CALENDAR_SELECTION} strokeWidth={1} />
        </g>
    );
};
